import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'

export const VerifierRoutes = () => {
  const User = useSelector(state => state.User)
  let isVerifier = User.user_type == 'Verifier'
  return (
    isVerifier ? <Outlet /> : <Navigate to='/error/' />
  )
}